<template>
	<div class="menu-right-container no-drag">
		<div class="top-sub-title-red" style="padding: 0; justify-content: center;">
			<div>
				<span class="bold" sty>경고 데이터</span>
			</div>
		</div>
		<div class="time-data">
			<template
			v-for="(patients) in topEmergencyList"
			>				
				<div class="data-btn" :key="'emer_' + patients.id" :class="newDataCheck(patients.recordDetailDate.substring(0, 20)) ? 'newdata' : ''" @click.stop="doOpenData(patients)">
					<div class="data-btn-left">
						{{ patients.id }}
					</div>
					<div class="data-btn-right">
						<span class="bold">{{ patients.name != '' ? patients.name : '-' }}</span>
						<div style="color:#A9A9A9;">
							<span class="font-red bold" style="font-size: 16px;">{{ getDataTotal(patients) }}</span>
							{{todayCheck(patients.recordDetailDate)}}
						</div>
					</div>
					<img class="data_go_btn" src="@/assets/images/home/data_go.png"/>
				</div>
			</template>
			<div class="none-list" style="border: none; height: 100%;" v-if="topEmergencyList.length == 0"> 
				현재 경고 상태인 산모가 없습니다.
			</div>
		</div>
		<div class="top-sub-title-red" style="padding: 0; justify-content: center; background-color: #0176F9;">
			<div>
				<span class="bold" sty>실시간 수신 데이터</span>
			</div>
		</div>
		<div class="time-data">
			<template
			v-for="(patients) in collectList"
			>				
				<div class="data-btn" :key="'emer_' + patients.id" @click.stop="doOpenData(patients)">
					<div class="data-btn-left">
						{{ patients.id }}
					</div>
					<div class="data-btn-right">
						<span class="bold">{{ patients.name != '' ? patients.name : '-' }}</span>
						<div style="color:#A9A9A9;">
							<span class="font-red bold" style="font-size: 16px;">{{ getDataTotal(patients) }}</span>
							{{todayCheck(patients.recordDetailDate)}}
						</div>
					</div>
					<img class="data_go_btn" src="@/assets/images/home/data_go.png"/>
				</div>
			</template>
			<div class="none-list" style="border: none; height: 100%;" v-if="collectList.length == 0"> 
				실시간 수신 데이터가 없습니다.
			</div>
		</div>
		<CollectDataPopup v-if="isCollectDataPopup" :collectData="collectData" />
	</div>
</template>

<script>
import EventBus from "@/script/EventBus.js";
import axios from "axios";
import CollectDataPopup from "@/components/collectData/CollectDataPopup.vue";
export default {
	name: "MenuRight",
	created() {
		this.logger.debug(this, "created()");
		this.selectEmergencyList();
		this.selectCollectList();
	},
	mounted() {
		this.logger.debug(this, ".mounted()");
		setInterval(this.selectEmergencyList, 30000);
		setInterval(this.selectCollectList, 30000);
	},
	beforeDestroy() {
		EventBus.$off('access-check');
	},
	components: {
		CollectDataPopup
	},
	props: {
		menuName: {
			type: String,
			required: true
		}
	},
	data() {
		return {
			items: {},
			isCollectDataPopup: false,
			collectData: {},
			emergencyList: [],
			topEmergencyList: [],
			collectList: [],
			userName: sessionStorage.getItem('userName'),
			homeUrl: this.config.contextRoot + "/home",
			menus: [
				{
					id: 1,
					name: "수집데이터 기록",
					url: this.config.contextRoot + "/collectData",
					path: "/collectData"
				},
				{
					id: 2,
					name: "참여자 목록",
					url: this.config.contextRoot + "/field",
					path: "/field"
				},
				{
					id: 3,
					name: "알림 관리",
					url: this.config.contextRoot + "/data_dictionary",
					path: "3"
				},
				{
					id: 4,
					name: "출산 후 관리",
					url: this.config.contextRoot + "/system_log",
					path: "4"
				},
				{
					id: 5,
					name: "코디네이터 목록",
					url: this.config.contextRoot + "/system_log",
					path: "5"
				},
				{
					id: 6,
					name: "회원가입 관리",
					url: this.config.contextRoot + "/system_log",
					path: "6"
				},
			]
		};
	},
	methods: {
		movePage(url) {
			this.logger.debug(this, "movePage(url)");
			if(url != this.config.contextRoot + "/setting/site"){
				this.$parent.menuNameSet(url);
				if (this.$route.path !== url) this.$router.push(url);
			}
			else{
				// let settingUrl = this.config.contextRoot + "/setting/" + 
				if (this.$route.path !== url){
					axios
						.post(this.config.contextRoot + "/access/selectSettingAccessUrl.do", {userId : sessionStorage.getItem("userId")})
						.then((response) => {
							console.log(response.data.url);
							if(response.data.url == 'false'){
								this.$alert("You are not authorized.","Warning","warning");
							}
							else{
								// this.$alert(window.location.href ,"Warning","warning");
								let url = this.config.contextRoot + "/setting/" + this.getProjectName(response.data.url);
								if (this.$route.path !== url)
								{
									// this.$router.push(url);
									location.href = this.config.contextRoot + "/setting" + this.getProjectName(response.data.url);
								}
							}
						})
						.catch((error) => {
							this.exceptionHandler(this, error);
						})
				}
			}
		},
		getProjectName(obj){
			let url = "";

			if(obj == 'ACCESS'){
				url = "/site";
			}
			else if(obj == 'EMR COLUMN MANAGE ACCESS'){
				url = "/emr_column_manage"
			}
			else if(obj == 'EMR DATA MANAGE ACCESS'){
				url = "/emr_data_manage"
			}
			return url;
		},
		doLogout() {
			this.logger.debug(this, "doLogout()");
			if (confirm("Would you like to log out?"))
			{
				this.$Auth.logout(
					function(logoutResult) {
						if (logoutResult){
							this.$router.push(this.config.contextRoot+"/");
							this.$router.go(0);
						}
						else
							this.logger.debug(this, "logoutResult:" + logoutResult);
					}.bind(this)
				);
			}
		},
		selectEmergencyList(){
			if(this.$route.path != '/home'){
				if(this.userName != ''){
					this.logger.debug(this, "selectEmergencyList()");
					this.openProjectIndex = -1;
					axios
						.post(this.config.contextRoot + "/home/selectEmergencyList.do", {searchText: this.searchText})
						.then((response) => {
							console.log(response);
							this.topEmergencyList = [];
							this.emergencyList = [];
							// if(response.data.emergencyList.length > 5){
							// 	for(var j = 0; j < 5; j++){
							// 		this.emergencyList.push(response.data.emergencyList[j]);
							// 	}
							// }
							// else{
								this.emergencyList = response.data.emergencyList;
							// }
							// this.allDataList = response.data.emergencyList;
		
							for(var i = 0; i < this.emergencyList.length; i++){
								if(this.emergencyList[i].status == 'EMERGENCY'){
									if(this.topEmergencyList.length < 5){
										this.topEmergencyList.push(this.emergencyList[i]);
									}
								}
								// if(this.emergencyList[i].emergencyCnt < 1 && this.emergencyList[i].cautionCnt > 0){
								// 	this.cautionList.push(this.emergencyList[i]);
								// }
							}
							// this.$nextTick(function () {
							// 	setTimeout(function() {
							// 		// 로딩바 닫기 요청
							// 		EventBus.$emit("project-loading", false);
							// 	}.bind(this), 400);
							// });
						})
						.catch((error) => {
							this.exceptionHandler(this, error);
						});
				}
			}
		},
		selectCollectList(){
			if(this.$route.path != '/home'){
				if(this.userName != ''){
					this.logger.debug(this, "selectCollectList()");
					this.openProjectIndex = -1;
					axios
						.post(this.config.contextRoot + "/collectData/selectCollectList.do", this.items)
						.then((response) => {
							console.log(response);
							this.collectList = [];
							for(var i = 0; i < response.data.collectList.length; i++){
								if(response.data.collectList[i].insertCnt > 0 && this.todayCheck(response.data.collectList[i].updateDate).indexOf('오늘') != -1){
									if(this.collectList.length < 5){
										this.collectList.push(response.data.collectList[i]);
									}
								}
							}
		
							EventBus.$emit("project-loading", false);
						})
						.catch((error) => {
							this.exceptionHandler(this, error);
						});
				}
			}
		},
		todayCheck(recordDate){
			const rDate = recordDate.substring(0, 10);
			const date = new Date();
			const year = date.getFullYear(); // YYYY
			const month = date.getMonth() + 1; // MM
			const day = date.getDate();	// DD
			const today = year + '-' + month.toString().padStart(2, '0') + '-' + day.toString().padStart(2, '0');
			if(rDate == today.substring(0, 11)){
				return "오늘 " + recordDate.substring(11, 19)
			}
			else{
				return recordDate.substring(0, 11)
			}
		},
		getDataTotal(patients){
			var result = "";

			if(patients.insertCnt == 0){
				result = '0건';
			}
			else{
				result = '총 ' + (patients.insertCnt) + '건';
			}
			return result;
		},
		getRecordType(recordType){
			var result = "";

			if(recordType == 'WEIGHT'){
				result = '체중'
			}
			if(recordType == 'BLOOD_PRESSURE'){
				result = '혈압'
			}
			if(recordType == 'BLOOD_GLUCOSE'){
				result = '혈당'
			}
			if(recordType == 'HEART_RATE'){
				result = '심박수'
			}
			if(recordType == 'STEP_COUNT'){
				result = '걸음수'
			}
			if(recordType == 'CALORIE'){
				result = '칼로리'
			}
			if(recordType == 'PROTEINURIA'){
				result = '단백뇨'
			}
			if(recordType == 'OXYGEN_SATURATION'){
				result = '산소포화도'
			}
			if(recordType == 'STRESS'){
				result = '스트레스'
			}
			if(recordType == 'SLEEP_TIME'){
				result = '수면시간'
			}

			return result;
		},
		getStatusType(status){
			var result = "정상";
			if(status == 'EMERGENCY'){
				result = '경고'
			}
			if(status == 'CAUTION'){
				result = '주의'
			}
			return result;
		},
		newDataCheck(recordDate){
			const rDate = new Date(recordDate);
			const nowDate = new Date();
			const resultDate = nowDate.getTime() - rDate.getTime();
			const resultMin = resultDate / (60*1000)
			if(resultMin < 10){
				return true;
			}
			else{
				return false;
			}
		},
		doOpenData(patients) {
			this.logger.debug(this, "doOpenData()");

			if(patients.dataList.length < 1){
				axios
						.post(this.config.contextRoot + "/home/selectData.do", patients)
						.then((response) => {
							console.log(response);
	
							patients.dataList = response.data.dataList;
							patients.managerList = response.data.managerList;
							this.isCollectDataPopup = true;
							this.collectData = patients;
							EventBus.$emit("project-loading", false);

						})
						.catch((error) => {
							this.exceptionHandler(this, error);
						});
			}
			else{
				this.isCollectDataPopup = true;
				this.collectData = patients;
			}
		},
	}
};
</script>

<style>
@import "../../assets/css/common/menu.css";
.menu-right-container{
	width: 360px;
    height: 100%;
    position: absolute;
    top: 80px;
    right: 0;
	transition: all 0.2s ease;
	box-shadow: -15px 0px 10px -15px #ccc;
}
.time-data{
	width: 100%;
	height: calc(50% - 104px);
	padding: 20px 16px;
	display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    row-gap: 10px;
}
.data-btn{
	min-width: 331px;
	height: 60px;
	border: 1px solid #C3C5CC;
	border-radius: 10px;
	display: flex;
	cursor: pointer;
	position: relative;
}
.data-btn-left{
	width: 62px;
	height: 100%;
	background-color: #F5F6FB;
	border-right: 1px solid #C3C5CC;
	border-top-left-radius: 10px;
	border-bottom-left-radius: 10px;
	font-size: 16px;
	font-weight: 500;
	display: flex;
	justify-content: center;
    align-items: center;
}
.data-btn-right{
	display: flex;
    flex-direction: column;
    justify-content: center;
    padding-left: 8.5px;
    row-gap: 5px;
    font-size: 14px;
}
.data_go_btn{
	width: 6px;
	height: 12px;
	position: absolute;
	top: calc(50% - 6px);
	right: 18.5px;
}
.none-list{
        height: 200px;
        border-top: 1px solid #ddd;
        border-bottom: 1px solid #ddd;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #ccc;
    }
</style>